// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__AgWLg","content":"style_content__4i1Wo","header":"style_header__rnTtY","subheader":"style_subheader__soDJK","footer":"style_footer__PDhsz"};